module.exports = __webpack_public_path__ + "img/tv.dd464742.jpeg";